export const Project_Variables = {
	createProjectConfirm: "Are you sure you want to create project?",
	cancelMsg: "Are you sure you want to cancel?",
	createProjectMsg: "Project created successfully",
	saveChangesConfirm: "Save changes?",
	saveChangesMsg: "Changes saved",
	react_select_style: {
		control: (base, state) => ({
			...base,
			borderRadius: "10px",
			outline: "0 !important",
			width: "100%",
			borderColor: state.isFocused ? null : null,
			boxShadow: state.isFocused ? null : null,
			border: "0",
			minHeight: "27px",
			height: "27px",
			fontSize: "12px",
			color: "#7ebfc0",
		}),

		indicatorSeparator: (base) => ({
			...base,
			display: "none",
		}),
		dropdownIndicator: (base) => ({
			...base,
			color: "#7ebfc0",
			marginTop: "-9px",
		}),
		clearIndicator: (base) => ({
			color: "#7ebfc0",
			marginBottom: "9px",
		}),
		valueContainer: (base) => ({
			...base,
			position: "initial !important",
		}),
		singleValue: (base) => ({
			...base,
			color: "#112f41",
		}),
	},
	react_multiselect_style: {
		control: (base, state) => ({
			...base,
			borderRadius: "10px",
			outline: "0 !important",
			width: "100%",
			borderColor: state.isFocused ? null : null,
			boxShadow: state.isFocused ? null : null,
			border: "0",
			minHeight: "27px",
			height: "auto",
			fontSize: "12px",
			color: "#7ebfc0",
		}),

		indicatorSeparator: (base) => ({
			...base,
			display: "none",
		}),
		dropdownIndicator: (base) => ({
			...base,
			color: "#7ebfc0",
		}),
		clearIndicator: (base) => ({
			color: "#7ebfc0",
			marginBottom: "9px",
		}),
		valueContainer: (base) => ({
			...base,
			position: "initial !important",
		}),
		singleValue: (base) => ({
			...base,
			color: "#112f41",
		}),
		multiValue: (base, state) => ({
			...base,
			background: "white",
			border: "1px solid #7ebfc0",
			borderRadius: 8,
		}),
		multiValueLabel: (base) => ({
			...base,
			color: "#7ebfc0",
		}),

		multiValueRemove: (base, state) => ({
			...base,

			borderRadius: 30,
			width: 20,
			height: 20,
			":hover": {
				backgroundColor: "teal",

				color: "white",
			},
		}),
	},
};
/* Display codes:
1:Text field->projectName
2:React-select dropdown->projectType
3:React-select dropdown->supervisor
4:React-select dropdown->allocateTo
5:Textarea field-Notes
 */
